//@ts-nocheck
import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Checkbox,
  Alert,
  AlertIcon,
  CheckboxGroup,
  Divider,
  FormControl,
  Flex,
  FormLabel,
  Popover,
  FormErrorMessage,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Select,
  SimpleGrid,
  Stack,
  Text,
  useTheme,
  useToast,
} from "@chakra-ui/react";
import { array, number, object, string } from "yup";
import { observer } from "mobx-react-lite";
import React from "react";
import { IScheduleStore } from "../stores";
import { SCHEDULE_DATA } from "../utils/data";
import { arrayToString, scrollToId } from "../utils/functions";
import { Formik, Form, Field } from "formik";
import { AccordionFormField } from "../_new_/components/accordion-form-field/AccordionFormField";

let commonProps = (
  { name }: { name: any },
  { touched, errors }: { touched: any; errors: any },
) => ({
  isInvalid: Boolean(touched[name] && errors[name]),
  errorMessage: errors[name],
});
export const CustomPopover = ({
  description,
  children,
}: {
  children: React.ReactNode;
  description: string;
}) => {
  return (
    <Popover>
      <PopoverTrigger>{children}</PopoverTrigger>
      <PopoverContent zIndex={4}>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverBody>{description}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

const PreferenceForm: React.FC<{ store: IScheduleStore }> = observer(
  ({ store, ...rest }) => {
    return (
      <Stack pt={2} spacing={6} {...rest}>
        <Stack pb={3}>
          <Text fontSize="2xl" fontWeight="bold">
            Lesson preference
          </Text>
          <Text color="gray.700">
            To ensure you get suitable bookings, please select your preference
            from the options below
          </Text>
        </Stack>
        <Field
          name="maxHours"
          render={({ field, form }: any) => {
            return (
              <FormControl isInvalid={commonProps(field, form).isInvalid}>
                <Flex alignItems="center" justifyItems="space-between">
                  <FormLabel fontWeight="normal" width={["60%", "60%", "40%"]}>
                    Maximum number of hours per class
                  </FormLabel>
                  <Box flex={1} display={["none", "block"]} />
                  <Select
                    size="lg"
                    fontSize="md"
                    isInvalid={commonProps(field, form).isInvalid}
                    width={["35%", "35%", "40%"]}
                    borderColor="neutral.500"
                    placeholder="Hours"
                    {...field}
                    onChange={(e) => {
                      form.setFieldValue(field.name, parseInt(e.target.value));
                    }}
                  >
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                  </Select>
                </Flex>
                <FormErrorMessage>
                  {commonProps(field, form).errorMessage}
                </FormErrorMessage>
              </FormControl>
            );
          }}
        />
        <Field
          name="maxDays"
          render={({ field, form }: any) => {
            return (
              <FormControl isInvalid={commonProps(field, form).isInvalid}>
                <Flex alignItems="center" justifyItems="space-between">
                  <FormLabel fontWeight="normal" width={["60%", "60%", "40%"]}>
                    Maximum number of classes per week
                  </FormLabel>
                  <Box flex={1} display={["none", "block"]} />
                  <Select
                    size="lg"
                    fontSize="md"
                    borderColor="neutral.500"
                    isInvalid={commonProps(field, form).isInvalid}
                    width={["35%", "35%", "40%"]}
                    {...field}
                    key={store.maxDays}
                    placeholder="Days"
                    onChange={(e) => {
                      form.setFieldValue(field.name, parseInt(e.target.value));
                    }}
                  >
                    {store.possibleDays.map((idx) => (
                      <option>{idx}</option>
                    ))}
                  </Select>
                </Flex>
                <FormErrorMessage>
                  {commonProps(field, form).errorMessage}
                </FormErrorMessage>
              </FormControl>
            );
          }}
        />
        <Field
          name="maxStudents"
          render={({ field, form }: any) => {
            return (
              <FormControl isInvalid={commonProps(field, form).isInvalid}>
                <Flex alignItems="center" justifyItems="space-between">
                  <FormLabel fontWeight="normal" width={["60%", "60%", "40%"]}>
                    Maximum number students per class
                  </FormLabel>
                  <Box flex={1} display={["none", "block"]} />
                  <Select
                    size="lg"
                    fontSize="md"
                    borderColor="neutral.500"
                    isInvalid={commonProps(field, form).isInvalid}
                    width={["35%", "35%", "40%"]}
                    placeholder="students"
                    {...field}
                    onChange={(e) => {
                      form.setFieldValue(field.name, parseInt(e.target.value));
                    }}
                  >
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                  </Select>
                </Flex>
                <FormErrorMessage>
                  {commonProps(field, form).errorMessage}
                </FormErrorMessage>
              </FormControl>
            );
          }}
        />
      </Stack>
    );
  },
);

export const WeeklyAvailability: React.FC<{
  availability: any;
  handleChange: (...params: any[]) => void;
}> = observer(({ availability, handleChange, ...rest }) => {
  const { daysOfTheWeek, emptySchedule, timeRange } = SCHEDULE_DATA;
  const { colors } = useTheme();
  return (
    <AccordionFormField
      options={daysOfTheWeek}
      isValid={(r) => availability[r.longDay] > 0}
      heading={(isExpanded, { longDay }) => (
        <>
          <Text fontWeight="medium">{longDay}</Text>
          {isExpanded ? (
            <Text fontSize="sm">Select your availability on {longDay}s</Text>
          ) : (
            availability[longDay].length > 0 && (
              <Text fontSize="xs" color="blue.500">
                {arrayToString(availability[longDay])}
              </Text>
            )
          )}
        </>
      )}
      renderFormField={({ longDay }) => {
        return (
          <Field
            name={longDay}
            render={({ field, form }: any) => {
              return (
                <CheckboxGroup
                  size="lg"
                  key={availability[longDay]}
                  defaultValue={availability[longDay]}
                  onChange={(val) => {
                    form.setFieldValue(field.name, val);
                    handleChange(longDay, val);
                    // console.log(availability[longDay].toJSON());
                  }}
                >
                  <SimpleGrid columns={[2, 3]} spacing={[6, 8]}>
                    {timeRange.map((option, i) => {
                      return (
                        <Checkbox
                          key={i}
                          value={option.range}
                          alignItems="flex-start"
                          borderColor="gray.200"
                        >
                          <Box ml={[0, 1]} mt={-1}>
                            <Text
                              fontWeight="medium"
                              lineHeight="short"
                              fontSize={["sm", "md"]}
                            >
                              {option.description}
                            </Text>
                            <Text opacity={0.7} fontSize="xs">
                              {option.range}
                            </Text>
                          </Box>
                        </Checkbox>
                      );
                    })}
                  </SimpleGrid>
                </CheckboxGroup>
              );
            }}
          />
        );
      }}
    />
  );
  return (
    <Accordion allowToggle border={0} {...rest}>
      {daysOfTheWeek.map(({ longDay }, idx) => {
        return (
          <AccordionItem mb={2} key={longDay} border={0}>
            {({ isExpanded }) => (
              <React.Fragment>
                <AccordionButton
                  px={[4, 5]}
                  py={4}
                  bg={isExpanded ? "gray.100" : "inherit"}
                  alignItems="center"
                  borderWidth="2xs"
                  borderRadius={isExpanded ? "8px 8px 0 0" : "8px"}
                  opacity={0.8}
                  _hover={{ bg: isExpanded ? "gray.200" : "gray.50" }}
                  _focus={{ outline: "none" }}
                  border={
                    !isExpanded && availability[longDay].length > 0
                      ? "1px solid lighblue"
                      : "1px solid lightgrey"
                  }
                  boxShadow={
                    !isExpanded && availability[longDay].length > 0
                      ? `0 0 0 1px ${colors.blue[400]}`
                      : "none"
                  }
                >
                  <Box flex="1" textAlign="left" mr={[3, 5]}>
                    <Text fontWeight="medium">{longDay}</Text>
                    {isExpanded ? (
                      <Text fontSize="sm">
                        Select your availability on {longDay}s
                      </Text>
                    ) : (
                      availability[longDay].length > 0 && (
                        <Text fontSize="xs" color="blue.500">
                          {arrayToString(availability[longDay])}
                        </Text>
                      )
                    )}
                  </Box>

                  {isExpanded ? (
                    <MinusIcon fontSize="12px" />
                  ) : (
                    <AddIcon fontSize="12px" />
                  )}
                </AccordionButton>
                <AccordionPanel
                  p={6}
                  borderWidth="2xs"
                  borderRadius="0 0 8px 8px"
                  borderTopWidth="none"
                  borderColor="neutral.500"
                >
                  <Field
                    name={longDay}
                    render={({ field, form }) => {
                      return (
                        <CheckboxGroup
                          size="lg"
                          key={availability[longDay]}
                          defaultValue={availability[longDay]}
                          onChange={(val) => {
                            form.setFieldValue(field.name, val);
                            handleChange(longDay, val);
                            // console.log(availability[longDay].toJSON());
                          }}
                        >
                          <SimpleGrid columns={[2, 3]} spacing={[6, 8]}>
                            {timeRange.map((option, i) => {
                              return (
                                <Checkbox
                                  key={i}
                                  value={option.range}
                                  alignItems="flex-start"
                                  borderColor="gray.200"
                                >
                                  <Box ml={[0, 1]} mt={-1}>
                                    <Text
                                      fontWeight="medium"
                                      lineHeight="short"
                                      fontSize={["sm", "md"]}
                                    >
                                      {option.description}
                                    </Text>
                                    <Text opacity={0.7} fontSize="xs">
                                      {option.range}
                                    </Text>
                                  </Box>
                                </Checkbox>
                              );
                            })}
                          </SimpleGrid>
                        </CheckboxGroup>
                      );
                    }}
                  />
                </AccordionPanel>
              </React.Fragment>
            )}
          </AccordionItem>
        );
      })}
    </Accordion>
  );
});
const validationSchema = object().shape({
  maxDays: number()
    .typeError("Please select a number")
    .required("Please select a value")
    .min(1),
  maxHours: number()
    .typeError("Please select a number")
    .required("Please select a value")
    .min(1),
  maxStudents: number()
    .typeError("Please select a number")
    .required("Please select a value")
    .min(1),
});
export type ScheduleProps = {
  store: IScheduleStore;
  onSubmit: any;
  formHeader?: string;
  label?: string;
  lockedDescription?: string;
  formSummary?: Array<any>;
  isCollapsed?: boolean;
  loading?: boolean;
  buttonProps?: any;
  buttonText?: string;
};
const ScheduleCard: React.FC<ScheduleProps> = observer(
  ({
    store,
    loading,
    onSubmit,
    buttonProps = {},
    buttonText = "Save and continue",
  }) => {
    const [showFormError, setShowFormError] = React.useState(false);
    const [selectedSchedule, setSelectedSchedule] = React.useState(0);
    const toast = useToast();
    const onSubmitClick = (errors = {}) => {
      if (errors) {
        if (Object.values(errors).length) {
          setShowFormError(true);
          scrollToId("form-header-section");
        } else {
          setShowFormError(false);
        }
      }
    };

    return (
      <Formik
        enableReinitialize
        initialValues={store.initialFormValues}
        validationSchema={validationSchema}
        onSubmit={(result) => {
          let { maxDays, maxHours, maxStudents, ...availability } = result;
          return onSubmit({ availability, maxDays, maxHours, maxStudents });
        }}
        render={({
          handleSubmit,
          values,
          errors,
          setErrors,
          setSubmitting,
        }) => {
          return (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                let all =
                  values.Friday.length +
                  values.Thursday.length +
                  values.Wednesday.length +
                  values.Tuesday.length +
                  values.Monday.length +
                  values.Sunday.length +
                  values.Saturday.length;
                if (all === 0) {
                  setSelectedSchedule(all);
                  onSubmitClick({
                    Friday: "At least one day",
                    Thursday: "At least one day",
                    Wednesday: "At least one day",
                    Tuesday: "At least one day",
                    Monday: "At least one day",
                    Sunday: "At least one day",
                    Saturday: "At least one day",
                  });
                  // setSubmitting(false);
                } else {
                  handleSubmit(e);
                  onSubmitClick(errors);
                }
              }}
            >
              <Stack spacing={6}>
                <Stack pb={2}>
                  <Text fontWeight="bold" fontSize={["3xl", "4xl"]}>
                    Your lesson schedule
                  </Text>
                  <Text color="gray.700">
                    Indicate the specific days and times you're available to
                    take lessons. Clients can book lessons with you based on
                    your schedule. You'll be notified to keep your calender
                    updated.
                  </Text>
                </Stack>

                {showFormError && (
                  <Stack id="form-header-section" py={4}>
                    <Box pt={2}>
                      <Alert rounded="lg" status="error">
                        <AlertIcon />
                        {`There are errors on this page`}
                      </Alert>
                      {selectedSchedule === 0 ? (
                        <Alert rounded="lg" status="error">
                          At least a day must be selected
                        </Alert>
                      ) : null}
                    </Box>
                  </Stack>
                )}

                <WeeklyAvailability
                  availability={values}
                  handleChange={(longDay, val) => {
                    store.setAvailability(longDay, val);
                  }}
                />
                <Divider borderColor="neutral.500" py={3} />
                <PreferenceForm store={store} />
                <Box pt={6}>
                  <Button
                    size="lg"
                    type="submit"
                    alignSelf="flex-start"
                    colorScheme="blue"
                    isLoading={loading}
                    loadingText="Saving details"
                    {...buttonProps}
                  >
                    {buttonText}
                  </Button>
                </Box>
              </Stack>
            </form>
          );
        }}
      ></Formik>
    );
  },
);

export default ScheduleCard;
